<template>
    <div class="produkt row my-4" ref="produkt"
        v-hammer:swipe.horizontal="(event) => produktWechseln(event)"
        v-hammer:tap="aufrufenProduktLink"
    >
        <div class="col-12 col-md-5 col-xl-4 mb-0 align-items-center">
            <div v-if="isLazyLoad" class="image-wrapper" :class="{'img-lazy-load': !istBildGeladen}">
                <img class="img-responsive" :src="srcProduktBild" ref="produktBild">
            </div>
            <img v-else class="img-responsive" :src="produkt.BILD_URL" ref="produktBild">
        </div>
        <div class="col-12 col-md-7 col-xl-8 m-0 mb-5 mb-md-0 py-4 flex-column text-white">
            <div class="produkt-beschreibung d-flex flex-column justify-content-center">
                <h2 class="fs-4 fs-md-6 noselect">{{ produkt.NAME }}</h2>
                <p class="fs-3 noselect">{{ produkt.UEBERSCHRIFT }}</p>
                <p class="fs-3 noselect">{{ produkt.UNTERUEBERSCHRIFT }}</p>
            </div>
            <div class="produkt-link d-flex justify-content-end justify-content-md-start align-items-end py-3">
                <a class="text-white" :href="produktLink">
                    {{ this.i18n.linktextZumProdukt }}
                </a>
                <span class="icon icon-angle-right" style="position: relative; top: 4px; margin-left: 6px;"></span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Produkt',
    props: {
        produkt: Object,
        i18n: Object,
        isLazyLoad: Boolean,
        srcBildPlatzhalter: String,
        herkunftIntern: String,
        paramKommeVon: String,
    },
    data() {
        return {
            triggered: false,
            startX: 0,
            deltaX: 0,
            startY: 0,
            deltaY: 0,
            lastDeltaX: 0,
            minDistance: 50,
            istBildGeladen: false,
            srcProduktBild: this.srcBildPlatzhalter,
            touchTime: 0,
        }
    },
    computed: {
        produktLink() {

            if (this.herkunftIntern && this.herkunftIntern != '') {
                if (this.paramKommeVon && this.paramKommeVon != '') {
                    return this.produkt.URL + '?' + this.herkunftIntern + '&' + this.paramKommeVon;
                }
                return this.produkt.URL + '?' + this.herkunftIntern;
            }

            if (this.paramKommeVon && this.paramKommeVon != '') {
                return this.produkt.URL + '?' + this.paramKommeVon;
            }

            return this.produkt.URL;
        }
    },
    methods: {
        parentWidth() {
            return this.$parent.$el.clientWidth;
        },
        produktEventStart(event) {
            if (event.button == 2) {
                return;
            }

            this.touchTime = new Date();
            this.triggered = true;
            this.startX = event.clientX || event.touches[0].clientX;
            this.startY = event.clientY || event.touches[0].clientY;
            window.addEventListener('mousemove', this.produktEventMove);
            window.addEventListener('touchmove', this.produktEventMove, {passive: false});
        },
        produktEventMove(event) {
            if (this.triggered) {
                event.preventDefault();
                let y = event.clientY || event.touches[0].clientY;
                this.deltaY = y - this.startY;

                if (Math.abs(this.deltaY) > 50) {
                    this.triggered = false;
                    this.deltaY = 0;
                    return false;
                }

                let x = event.pageX || event.touches[0].pageX;
                this.deltaX = x - this.startX;
                this.lastDeltaX = this.deltaX;
            }

        },
        produktEventEnd(event) {
            if (event.button == 2) {
                return;
            }

            var diff = new Date() - this.touchTime;

            if (diff < 100) {
                this.triggered = false;
                location.href = this.produkt.URL;
                return true;
            }

            this.triggered = false;
            if (Math.abs(this.deltaX) > this.minDistance) {
                if (this.deltaX < 0) {
                    this.$emit('produkt-next', this.produkt.produktId);
                } else {
                    this.deltaX = 0;
                    this.$emit('produkt-prev', this.produkt.produktId);
                }
            }

            window.removeEventListener('mousemove', this.produktEventMove);
            window.removeEventListener('touchmove', this.produktEventMove);
            return false;

        },
        produktWechseln(event) {
            if (event.direction == window.Hammer.DIRECTION_LEFT) {
                this.$emit('produkt-next', this.produkt.produktId);
            }

            if (event.direction ==  window.Hammer.DIRECTION_RIGHT) {
                this.$emit('produkt-prev', this.produkt.produktId);
            }

        },
        aufrufenProduktLink() {
            location.href = this.produktLink;
        },
        ersetzenPlatzhalterBild() {
            this.istBildGeladen = true;
            this.srcProduktBild = this.produkt.BILD_URL;
        }
    },
    mounted() {
        if (this.isLazyLoad) {
            let bild = new Image();
            bild.src = this.produkt.BILD_URL;

            if (bild.complete) {
                this.ersetzenPlatzhalterBild();
            } else {
                bild.addEventListener('load', this.ersetzenPlatzhalterBild);
            }
        }
    }
}

</script>

<style lang="scss" scoped>

    .produkt {
        cursor: pointer;

        &:hover {
            text-decoration: none;
        }

        .image-wrapper {

            img {
                border-radius: 7px;
            }

            &.img-lazy-load {
                width: 100%;
                height: 0;
                padding-bottom: 100%;
            }
        }

        .produkt-informationen {
            padding: 5px;
        }

        .produkt-beschreibung h2 {
            color: #ffffff;
        }

        .produkt-beschreibung p {
            margin-bottom: 0;
        }

        .noselect {
          -webkit-touch-callout: none;
            -webkit-user-select: none;
               -moz-user-select: none;
                -ms-user-select: none;
                    user-select: none;
        }
    }


</style>

